/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_What_Is_Gridcraft_Sections_1_TitleInputs */

const en_gc_search_guides_what_is_gridcraft_sections_1_title = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Find your way around the spreadsheet`)
};

const zh_gc_search_guides_what_is_gridcraft_sections_1_title = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`认识电子表格工作区`)
};

/**
* | output |
* | --- |
* | "Find your way around the spreadsheet" |
*
* @param {Gc_Search_Guides_What_Is_Gridcraft_Sections_1_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_what_is_gridcraft_sections_1_title = /** @type {((inputs?: Gc_Search_Guides_What_Is_Gridcraft_Sections_1_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_What_Is_Gridcraft_Sections_1_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_what_is_gridcraft_sections_1_title(inputs)
	return zh_gc_search_guides_what_is_gridcraft_sections_1_title(inputs)
});
export { gc_search_guides_what_is_gridcraft_sections_1_title as "gc.search_guides.what_is_gridcraft.sections.1.title" }